import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { HeaderComponent } from "./header/header.component";
import { HeaderListMachineComponent } from "./header/header-list-machine/header-list-machine.component";
import { HeaderSignUpComponent } from "./header/header-sign-up/header-sign-up.component";
import { HeaderLoginComponent } from "./header/header-login/header-login.component";
import { HeaderLearnMoreComponent } from "./header/header-learn-more/header-learn-more.component";
import { HeaderCartComponent } from "./header/header-cart/header-cart.component";
import { HeaderAccountComponent } from "./header/header-account/header-account.component";
import { HeaderOverlayComponent } from "./header/header-overlay/header-overlay.component";
import { SearchSuggestsOverlayComponent } from "./body/search-suggests-overlay/search-suggests-overlay.component";
import { HeaderSearchComponent } from "./header/header-search/header-search.component";
import { SignUpModalComponent } from "./modals/sign-up-modal/sign-up-modal.component";
import { LogInModalComponent } from "./modals/log-in-modal/log-in-modal.component";
import { TopBarNavigationComponent } from "./body/top-bar-navigation/top-bar-navigation.component";
import { FooterComponent } from "./footer/footer.component";
import { CommonModule } from "@angular/common";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from "../forms/forms.module";
import { FormsModule as AngularFormsModule, ReactiveFormsModule } from "@angular/forms";
import { SideBarNavigationComponent } from "./body/side-bar-navigation/side-bar-navigation.component";
import { RubblSharedModule } from "../rubbl-shared/rubbl-shared.module";
import { CancelConfirmModalComponent } from "./modals/cancel-confirm-modal/cancel-confirm.modal.component";
import { MobileModalComponent } from "./modals/mobile-modal/mobile-modal.component";
import { InternalHeaderComponent } from "./internal-header/internal-header.component";
import { InternalHeaderAccountComponent } from "./internal-header/internal-header-account/internal-header-account.component";
import { SearchResultsModule } from "../search-results/search-results.module";
import { HeaderPhoneComponent } from "./header/header-phone/header-phone.component";
import { HowItWorksModalComponent } from "./modals/how-it-works-modal/how-it-works-modal.component";
import { MarketingModule } from "../marketing/marketing.module";
import { BottomNavigationComponent } from "./bottom-navigation/bottom-navigation.component";

@NgModule({
  declarations: [
    HeaderComponent,
    HeaderListMachineComponent,
    HeaderSignUpComponent,
    HeaderLoginComponent,
    HeaderLearnMoreComponent,
    HeaderCartComponent,
    HeaderAccountComponent,
    HeaderOverlayComponent,
    SearchSuggestsOverlayComponent,
    HeaderSearchComponent,
    SignUpModalComponent,
    LogInModalComponent,
    TopBarNavigationComponent,
    FooterComponent,
    SideBarNavigationComponent,
    CancelConfirmModalComponent,
    MobileModalComponent,
    InternalHeaderComponent,
    InternalHeaderAccountComponent,
    HeaderPhoneComponent,
    HowItWorksModalComponent,
    BottomNavigationComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    AngularFormsModule,
    ReactiveFormsModule,
    RubblSharedModule,
    SearchResultsModule,
    MarketingModule,
  ],
  exports: [
    HeaderComponent,
    HeaderOverlayComponent,
    SearchSuggestsOverlayComponent,
    FooterComponent,
    TopBarNavigationComponent,
    SideBarNavigationComponent,
    MobileModalComponent,
    InternalHeaderComponent,
    BottomNavigationComponent,
  ],
})
export class LayoutModule {}
